<template>
    <div class="flex items-start space-x-4 text-base sm:text-sm">
        
        <div class="flex-none mt-1">
            <a :href="`/${opportunity.id}/${opportunity.slug}`" :title="opportunity.title" class="guide-img-container">
                <img class="object-cover w-8 rounded-lg shadow-lg"
                     :src="opportunity.imageUrl"
                     :alt="opportunity.title"
                     :title="opportunity.title">
            </a>
        </div>
        
        <div class="flex-grow">
            <a :href="`/${opportunity.id}/${opportunity.slug}`" :title="opportunity.title" class="block font-medium hover:underline">
                <h3 class="">{{ opportunity.title }}</h3>
            </a>
            <dl>
                <dt class="sr-only">Category</dt>
                <dd class="">
                    <span class="text-xs">{{ opportunity.category }}</span>
                </dd>
            </dl>
        </div>
        

    </div>

</template>

<script lang="ts" setup>
import {defineProps} from "vue";
import {OpportunityDTOLightweight} from "@/dtos";

const props = defineProps<{
    opportunity: OpportunityDTOLightweight,
}>();

const opportunity = props.opportunity;
</script>
<style>

</style>